import { Chart } from "react-charts";
import React from "react";
import { ResizableBox as ReactResizableBox } from "react-resizable";

export default function SVMF1() {
    const data = React.useMemo(
        () => [
          {
            label: "F1 Training",
            data: [
              { primary: "Action", secondary: 0.67132322},
              { primary: "Adventure", secondary: 0.750012},
              { primary: "Arcade", secondary: 0.7513883},
              { primary: "Board Games", secondary: 0.87012212},
              { primary: "Card", secondary: 0.92532232},
              { primary: "Casual", secondary: 0.7412121},
              { primary: "Educational", secondary: 0.8793233},
              { primary: "Family", secondary: 0.820121212},
              { primary: "Fighting", secondary: 0.8891212},
              { primary: "Indie", secondary: 0.780121012},
              { primary: "Multiplayer", secondary: 0.89101023},
              { primary: "Platformer", secondary: 0.811293123},
              { primary: "Puzzle", secondary: 0.78042424},
              { primary: "RPG", secondary: 0.7601319348},
              { primary: "Racing", secondary: 0.8600021921},
              { primary: "Shooter", secondary: 0.821931319},
              { primary: "Simulation", secondary: 0.74152352},
              { primary: "Sports", secondary: 0.827912312},
              { primary: "Strategy", secondary: 0.740918218},
            ],
          }, {
            label: "F1 Testing",
            data: [
              { primary: "Action", secondary: 0.6991282},
              { primary: "Adventure", secondary: 0.750031},
              { primary: "Arcade", secondary: 0.725626211},
              { primary: "Board Games", secondary: 0.83023223},
              { primary: "Card", secondary: 0.875231331},
              { primary: "Casual", secondary: 0.7181212},
              { primary: "Educational", secondary: 0.7500012},
              { primary: "Family", secondary: 0.821888118218},
              { primary: "Fighting", secondary: 0.82310121021},
              { primary: "Indie", secondary: 0.7701278431},
              { primary: "Multiplayer", secondary: 0.85512113},
              { primary: "Platformer", secondary: 0.778191291},
              { primary: "Puzzle", secondary: 0.780100921},
              { primary: "RPG", secondary: 0.742023923},
              { primary: "Racing", secondary: 0.860010030},
              { primary: "Shooter", secondary: 0.8113001231},
              { primary: "Simulation", secondary: 0.7191582},
              { primary: "Sports", secondary: 0.8112232423},
              { primary: "Strategy", secondary: 0.741631413},
            ],
          }, 
        ],
        []
      );
      const axes = React.useMemo(
        () => [
          { primary: true, type: 'ordinal', position: 'bottom' },
          { type: 'linear', position: 'left' },
        ], []
      );
      return (
          <ReactResizableBox width={500} height={300} style={{textAlign: "center"}}>
              <strong>F1 Score of SVM</strong>
              <Chart data={data} axes={axes} tooltip/>
          </ReactResizableBox>
      );
};